import { EnglishStr } from "@/lib/EnglishStr";
import ErrorTemplate from "./ErrorTemplate";

export default function InvalidSSOError() {
  return (
      <ErrorTemplate
        title="Sorry, we’re experiencing some issues"
        content="Please log back into your online banking and try again."
      />
    );
}
